import React, { useState, useRef, useEffect, useCallback } from 'react';
import Classes from './ProductSection.module.css';
import { useNavigate } from 'react-router-dom';
import ProductItem from './ProductItem';
import { AllProducts } from '../../../data/products';

const BATCH_SIZE = 5;
const MAX_AUTO_BATCHES = 5; // 5 batches of 5 = 25 products

export default function ProductSection() {
    const navigateTo = useNavigate();
    const [currentBatch, setCurrentBatch] = useState(1);
    const loaderRef = useRef(null);

    const visibleProducts = AllProducts.slice(0, currentBatch * BATCH_SIZE);

    const handleLoadMore = useCallback(() => {
        setCurrentBatch((prev) => prev + 1);
    }, []);

    // Auto load more on scroll
    useEffect(() => {
        if (currentBatch >= MAX_AUTO_BATCHES) return;

        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                handleLoadMore();
            }
        }, { threshold: 1 });

        if (loaderRef.current) {
            observer.observe(loaderRef.current);
        }

        return () => {
            if (loaderRef.current) observer.unobserve(loaderRef.current);
        };
    }, [handleLoadMore, currentBatch]);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <h3>Available Products</h3>
                <button onClick={() => navigateTo('/all-products')} className={Classes.primaryBtn}>
                    <h5>More Products</h5>
                </button>
            </div>

            <div className={Classes.body}>
                {visibleProducts?.map((product, index) => (
                    <ProductItem
                        key={`${product.id}-${index}`}
                        product={product}
                        index={index}
                    />
                ))}
            </div>

            {/* 👇 Invisible trigger for auto batch loading */}
            {currentBatch < MAX_AUTO_BATCHES && (
                <div ref={loaderRef} style={{ height: 1 }} />
            )}

            {/* 👇 Button after 100 products */}
            {visibleProducts?.length < AllProducts?.length && currentBatch >= MAX_AUTO_BATCHES && (
                <div style={{ textAlign: 'center' }}>
                    <button className={`${Classes.primaryBtn} ${Classes.showMoreBtn}`} onClick={handleLoadMore}>
                        <h5>Load More Products</h5>
                    </button>
                </div>
            )}
        </div>
    );
}
